module.exports = __webpack_public_path__ + "assets/media/evening.ef5f3506.mp3";